// Mirrors server/src/helpers/payroll/shiftTravel.js - paid travel time
// either side of a shift's on-site window, at its own hourly rate.

const toMinutes = (value) => {
  const minutes = Number(value)
  return Number.isFinite(minutes) && minutes > 0 ? Math.round(minutes) : 0
}

export const getTravelMinutes = (travel) =>
  toMinutes(travel?.beforeMinutes) + toMinutes(travel?.afterMinutes)

export const hasPaidTravel = (travel) =>
  getTravelMinutes(travel) > 0 && (Number(travel?.rate) || 0) > 0

export const getTravelPay = (travel) =>
  hasPaidTravel(travel)
    ? Math.round((getTravelMinutes(travel) / 60) * Number(travel.rate) * 100) /
      100
    : 0

// Shift -> editor state: null when the shift carries no travel so the
// editor shows its "Add paid travel time" button instead of empty fields
export const toTravelDraft = (travel) =>
  getTravelMinutes(travel) || Number(travel?.rate) > 0
    ? {
        beforeMinutes: travel?.beforeMinutes ?? '',
        afterMinutes: travel?.afterMinutes ?? '',
        rate: travel?.rate ?? '',
      }
    : null

// 90 -> "1h 30m", 60 -> "1h", 45 -> "45m"
export const formatTravelMinutes = (minutes) => {
  const total = toMinutes(minutes)
  if (!total) return '0m'
  const hours = Math.floor(total / 60)
  const mins = total % 60
  return [hours ? `${hours}h` : '', mins ? `${mins}m` : ''].filter(Boolean).join(' ')
}

// "1h 30m before + 1h after @ £12.50/hr"
export const formatTravelSummary = (travel, currency = '£') => {
  if (!getTravelMinutes(travel)) return ''
  const parts = []
  if (toMinutes(travel?.beforeMinutes)) {
    parts.push(`${formatTravelMinutes(travel.beforeMinutes)} before`)
  }
  if (toMinutes(travel?.afterMinutes)) {
    parts.push(`${formatTravelMinutes(travel.afterMinutes)} after`)
  }
  const rate = Number(travel?.rate) || 0
  return `${parts.join(' + ')}${rate ? ` @ ${currency}${rate}/hr` : ''}`
}
